<ng-container *ngIf="isLoading else pageContent">
	<div class="app-spinner">
		<mat-spinner></mat-spinner>
	</div>
</ng-container>


<ng-template #pageContent>
	<div class="container-fluid justify-content-center">
		<div class="row d-flex shadow-lg overflow-hidden box-cont">
			<div class="col-md-6 d-md-block p-0">
            <div class="auth-left-image">
  <img src="assets/images/login.jpg" class="img-fluid bg-img" alt="user-image"/>

  <div class="overlay"></div>
  <div class="content">

	  <img src="assets/images/logo_white.png" class="img-fluid logo" alt="App Logo" routerLink="/" />

    <span class="badge">
		<i class="bi bi-stars"></i>
		Transform Your Career</span>
    <h1> Your Path to <br /> Career Success</h1>

    <p class="subtitle">
      Join thousands of students who have transformed their careers with our
      comprehensive learning platform.
    </p>

    <div class="features">
      <div class="feature-card">
        <i class="bi bi-journal-text"></i>
        <div>
          <h6>Professional Courses</h6>
          <p>Unlimited access to industry-relevant courses</p>
        </div>
      </div>

      <div class="feature-card">
        <i class="bi bi-clipboard-check"></i>
        <div>
          <h6>Placement Prep</h6>
          <p>Aptitude tests & interview preparation</p>
        </div>
      </div>

      <div class="feature-card">
        <i class="bi bi-mic"></i>
        <div>
          <h6>AI Interview Coach</h6>
          <p>Practice with AI-powered mock interviews</p>
        </div>
      </div>

      <div class="feature-card">
        <i class="bi bi-person-video3"></i>
        <div>
          <h6>Expert Mentorship</h6>
          <p>Get guidance from industry Professional</p>
        </div>
      </div>

	  <div class="feature-card">
        <i class="bi bi-graph-up"></i>
        <div>
          <h6>Track Progress</h6>
          <p>Monitor your growth with analytics</p>
        </div>
      </div>
    </div>
</div>
</div>
</div>
			<div class="col-md-6 img-bg-color2 scroll pt-5 mt-5">
				<div class="text-center mb-2">
					<img src="assets/images/lock.png" class="img-fluid lock-img">
				</div>
				<h2 class="text-center create-account mt-3">Forgot Password?</h2>
				<p class="text-center sub-head pt-2">Enter your email to reset your password</p>

				<form [formGroup]="form" (ngSubmit)="forgotPassword()">
					<div class="col-md-10 mb-3 offset-md-1 mt-4">
						<div class="floating-label-wrapper">

							<i class="bi bi-envelope input-icon"></i>
							<input type="email" formControlName="email" class="form-control floating-input" id="email"
								[placeholder]="getEmailPlaceholder()" (focus)="onEmailFocus()" (blur)="onEmailBlur()" />
							<label [class.floating]="shouldFloatEmailLabel()" for="email">
								Email
							</label>
						</div>

						<small *ngIf="form.controls['email'].invalid && form.controls['email'].touched"
							class="text-danger smaller-text ">Please enter a valid email address</small>
					</div>


					<div class="col-md-10 mb-3 offset-md-1">
						<button type="submit" class="btn-signup w-100" [disabled]="form.invalid">Submit</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</ng-template>